/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Mulai_HowInputs */

const en_simple_mulai_how = /** @type {(inputs: Simple_Mulai_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const id_simple_mulai_how = /** @type {(inputs: Simple_Mulai_HowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara kerjanya`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Simple_Mulai_HowInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_mulai_how = /** @type {((inputs?: Simple_Mulai_HowInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Mulai_HowInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_mulai_how(inputs)
	return en_simple_mulai_how(inputs)
});